// Display-only helper: the price a buyer sees on a sent deal is the seller's set
// price marked up by the car's tax rate. This does not change what's actually
// submitted/stored as a bid amount — it's purely a presentational calculation.
export function withTax(price, taxRatePercent) {
  const p = Number(price) || 0;
  const t = Number(taxRatePercent) || 0;
  return Math.round(p * (1 + t / 100) * 100) / 100;
}
